// @ts-nocheck
import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from "../../../../../../stores/mobx-compat";
import AceEditor from 'react-ace';
import beautify from 'js-beautify';

import Button from '../../../../../ui/Button';
import FormGroup from '../../../../../ui/FormGroup';
import Input from '../../../../../ui/Input';
import { RefreshIcon, EditIcon } from '../../../../../ui/icons';

import 'ace-builds/src-noconflict/mode-handlebars';
import 'ace-builds/src-noconflict/snippets/handlebars';
import 'ace-builds/src-noconflict/theme-monokai';
import 'ace-builds/src-noconflict/ext-language_tools';

class TemplateDropdown extends Component {
  constructor(props) {
    super(props);
    const { template = {} } = this.props;

    this.originalTemplate = beautify.html(template.template, {
      indent_size: 2,
      preserve_newlines: true,
      max_preserve_newlines: 1,
      indent_handlebars: true,
      indent_inner_html: true,
      indent_with_tabs: false,
    });

    this.static = {
      name: template.name,
      versionTag: template.tag,
      createdAt: template.createdAt,
      active: template.active,
    };

    this.state = {
      description: template.description,
      comment: template.comment,
      template: this.originalTemplate,
    };
  }

  set = (name, value) => this.setState({ [name]: value });

  render() {
    const em = this.props.store.emailManagement;
    return (
      <>
        <div className="grid gap-3 mb-4" style={{ gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' }}>
          {_.map(this.static, (val, key) => (
            <FormGroup key={key} label={_.startCase(key)}>
              <Input value={_.isBoolean(val) ? String(val) : val || ''} readOnly />
            </FormGroup>
          ))}
          <FormGroup label="Description">
            <Input value={this.state.description || ''} onChange={(e) => this.set('description', e.target.value)} />
          </FormGroup>
          <FormGroup label="Comment">
            <Input value={this.state.comment || ''} onChange={(e) => this.set('comment', e.target.value)} />
          </FormGroup>
        </div>

        <div
          className="mb-4"
          style={{ background: '#272822', borderRadius: 10, overflow: 'hidden', border: '1px solid var(--mov-line-strong)' }}
        >
          <div
            className="mov-mono"
            style={{
              padding: '8px 12px', fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase',
              color: '#ccc6b6', background: '#1f2122', borderBottom: '1px solid #333',
            }}
          >
            HTML
          </div>
          <AceEditor
            mode="handlebars"
            theme="monokai"
            name="html"
            value={this.state.template}
            onChange={(v) => this.setState({ template: v })}
            fontSize={13}
            tabSize={2}
            enableBasicAutocompletion
            highlightActiveLine
            showPrintMargin={false}
            width="100%"
            height="360px"
            editorProps={{ $blockScrolling: true }}
          />
        </div>

        <div className="flex gap-2 justify-end">
          <Button icon={RefreshIcon} onClick={() => this.setState({ template: this.originalTemplate })}>
            Undo HTML changes
          </Button>
          <Button
            variant="primary"
            icon={EditIcon}
            loading={em.loading.updateTemplate}
            disabled={em.loading.updateTemplate}
            onClick={() => em.updateTemplate({ ...this.static, ...this.static, ...this.state })}
          >
            Update template
          </Button>
        </div>
      </>
    );
  }
}

export default inject('store')(observer(TemplateDropdown));
